// extracted by mini-css-extract-plugin
export default {"container":"ConfirmInvoiceModal_container__t33-x","modal_contents":"ConfirmInvoiceModal_modal_contents__C-FlC","loading_spinner":"ConfirmInvoiceModal_loading_spinner__Drjwu"};